import type {Key} from 'react';
import type {
  Node,
  Collection as ReactAriaCollection,
  Selection,
} from '@react-types/shared';

export const mapSelectionToKeysSet = (
  selection: 'all' | Iterable<Key> | undefined,
  collection: ReactAriaCollection<Node<unknown>>,
): Set<Key> => {
  let keys: Selection = new Set();
  if (selection === 'all') {
    keys = new Set([...collection.getKeys()]);
  } else if (selection) {
    keys = new Set(selection);
  }

  return keys;
};
